/* global espn_ui espn twttr jQuery */
import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { composeView, GlobalNavTertiary } from '../components/gamepackage'
import { GameStrip, GameDetailsFooter, LongStripAd } from '../components/gamepackage/GameStrip'
import { GlobalNavTertiary as GlobalNavTertiaryLite } from '../components/gamepackage/cricket/lite'
import { FooterLite } from '../components/common/lite'
import { getGamePackage } from '../actions/api'
import { gamepackageFastCast, disconnectGPG } from '../actions/fastcast/cricket'
import { postCommentryFeedback } from '../actions/utils'
import { Ad } from '../components/common'
import { hasRouteChanged, poll, getAdSimplifiedLink } from '../lib/utils/common'
import selectn from 'selectn'
import { bindActionCreators } from 'redux'
import { updateGameStrip } from '../actions'
@connect(state => {
  return { ...state.gamePackage, ...state.utils, edition: state.page.edition }
}, dispatch => {
  return { dispatch, postCommentryFeedback : bindActionCreators(postCommentryFeedback, dispatch) }
})

export default class GamePackage extends React.Component {

  constructor() {
    super()
    this.timer = null
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    ads: PropTypes.object.isRequired
  }

  static loadActions = [
    getGamePackage
  ]

  componentDidMount() {
    const { fastCastMeta = {}, isFastcastAllowed, edition, params, meta, gameState } = this.props
    // Init webviews
    this.initWebViews(this.props, 'init')
    this.props.ads.updateKeyValue(edition, params, meta, gameState)
    this.props.ads.init()
    this.spliceShell()
    this.props.ads.loadInViewAds()

    /**
     * Gamestrip times need to be updated when that game is in prestate
     */
    if(gameState === 'pregame') {
      this.props.dispatch(updateGameStrip(params.sport))
    }

    /**
     * Initiate Fastcast connection (if fastcast is available for this sports) and Ajax polling
     * if Fastcast connection is successfull Ajax polling will be disabled
     */
    if (fastCastMeta.enabled === true) {
      //console.info('Setup fastcast since match is live')
      gamepackageFastCast.call(this, null)
    }
    // if Fastcast is not allowed initiat ajax polling
    if (isFastcastAllowed !== true) {
      //console.info('fastcast is not available')
      poll.call(this, GamePackage.loadActions)
    }
    if(selectn('edition.isEspnCricinfo', this.props)) {
      const duration = selectn('edition.isAsiaRegion', this.props) ? 90000 : 300000
      this.props.ads.refreshInPageAdSlots(duration)
    }
  }

  initWebViews(props = {}, action) {
    const platform = selectn('params.platform', props)
    if (typeof platform !== 'undefined') {
      const meta = selectn('meta', props)
      const allVideos = (selectn('allVideos.videos', props) || [])
        .slice(0) // clone in case other components are reading `allVideos.videos` node
        .concat(selectn('article.video', props) || []) // append any videos in preview/report
      const sliderVideos = selectn('videoSlider.videos', props) || [] // this WAS hardcoded to read this.props, even in 'componentWillReceiveProps', @TODO change back if that was intentional, I'm assuming it was a mistake
      const lecclips = selectn('lecclips', props) || []
      const rosterVideos = selectn('rosterVideos', props) || []
      this.props.webviews.init(platform, meta, allVideos, sliderVideos, lecclips, rosterVideos, action)
    }
  }

  /*
  * The statement below checks if its a page load or tab switch
  * If there is a change in URL, will trigger a webview init with all latest videos
  * Videos for webviews after geo filtering on props change will happen on props change
  * "init" will update meta information as well
  */
  componentWillReceiveProps(nextProps) {
    let { fastCastMeta = {}, isFastcastAllowed } = nextProps
    const currentUrl = selectn('meta.canonical', nextProps)
    const previousUrl = selectn('meta.canonical', this.props)
    // updates meta related info and videos on tab switch
    this.initWebViews(nextProps, (!previousUrl || (previousUrl !== currentUrl)) ? 'init' : 'onstatechange')
    //poll.call(this, GamePackage.loadActions)
    /**
     * Initiate Fastcast connection (if fastcast is available for this sports) and Ajax polling
     * if Fastcast connection is successfull Ajax polling will be disabled
     */
    if (fastCastMeta.enabled === true) {
      //console.info('Setup fastcast since match is live')
      gamepackageFastCast.call(this, null)
    }
    // if Fastcast is not allowed initiat ajax polling
    if (isFastcastAllowed !== true) {
      //console.info('fastcast is not available')
      poll.call(this, GamePackage.loadActions)
    }
  }

  componentDidUpdate(prevProps = {}) {
    const { location, edition, params, meta, gameState } = this.props
    // Refresh ads only if there is a change in route
    if(hasRouteChanged(prevProps.location, location)) {
      this.props.ads.inviewAdRevert()
      this.props.ads.updateKeyValue(edition, params, meta, gameState)
      this.props.ads.init()
      this.props.ads.loadInViewAds()
      try {
        const activeVideoThumb = jQuery('.video.active')
        espn.video.remove()


        let $container = jQuery('.top-highlights .mediaList__list')
        let nextVideo = $container.find('.mediaList__item--next')
        let currentVideo = $container.find('.mediaList__item--active')

        if (activeVideoThumb.length) {
          activeVideoThumb.removeClass('active')
          currentVideo.removeClass('mediaList__item--active').find('.mediaList__phase').remove()
          nextVideo.find('.mediaList__phase').remove()
        }
      } catch (ReferenceError) {
        // document is not defined
      }
    }
    this.spliceShell()
  }

  componentWillUnmount() {
    window.clearInterval(this.timer)
    this.timer = null
    // disable event handlers
    let platform = selectn('params.platform',this.props)
    if(typeof platform !== 'undefined') {
      this.props.webviews.disableInterceptor()
    }
    disconnectGPG.call(this, null)
  }

  spliceShell() {
    try{
      // init Behaviors for articles
      espn_ui.LoadBehavior(document.querySelectorAll('.main-content.react-content :not(.app_partial)'))
      // update meta data
      this.props.updateMeta(this.props.meta)
      // set league prop (for video tracking in report?)
      espn.gamepackage = espn.gamepackage || {}
      espn.gamepackage.league = this.props.params.league
      // load twitter widgets
      twttr.widgets.load()
    }catch(e) {
      if (e instanceof ReferenceError && e.message === 'twttr is not defined') {
        console.log('Error loading twitter widget')
      }
      else{
        console.log(e)
      }
    }
  }

  render() {
    const { gameStateClass, summary, matchSummary, params, location, gameStrip, links = [], showGameDetailFooter, leagueUid, detailsHeaderClass, loading, gameState, appProps = {}, matchShortName, edition, trackingImg, showBtmAdModule, siteType, showGameHeader } = this.props
    const { sport, pageType } = params
    const isWebView = params.platform ? true : false
    const mainContainerClass = `${ loading ? 'loading' : ''}`
    const isMobile = selectn('device.mobile', appProps)
    const isAppLite = appProps.isAppLite
    const isDataLite = (siteType === 'data-lite') ? true : false
    // Compose the game package view
    
    const appView = composeView({
      pageType: pageType,
      state: { ...this.props, isWebView, isMobile },
      params,
      query : location.query,
      isAppLite
    })

    const simplifiedAdLink =  getAdSimplifiedLink(this.props.edition, params.pageType)

    if (isAppLite) {
      return (
        <div>
          <div style={{ maxHeight:'1px', position: 'absolute' }}><img id="omniture" src={trackingImg} alt="" width="1" height="1" /></div>
          <div key="hd" className="cricinfo__header">
            { !isWebView &&
              <div className="cricinfo__header__logo">
                <a href="/" className="cricinfo__header__logo__link">
                  <img src="http://a.espncdn.com/i/cricinfo/logo_cricinfo@2x.png" alt="ESPN Cricinfo" className="cricinfo__header__logo__img" height="16" width="126"/>
                </a>
              </div>
            }
            <h1 className="cricinfo__header__title">{matchShortName}</h1>
            <GlobalNavTertiaryLite links={links} activeKey={pageType} />
          </div>

          <div key="ad" className="ad-slot ad-slot-banner ad-wrapper" style={{ 'textAlign': 'center' }}>
            <div className="ad">
            <a href={simplifiedAdLink.link}><img src={simplifiedAdLink.src} /></a>
            </div>
          </div>

          {appView}

          <div>
            <div className="cricinfo__content__item">
              <a href="#" className="cricinfo__type__link cricinfo__type__link--back-to-top ">
                <span>Back to top </span>
                <div className="cricinfo__caret"></div>
              </a>
            </div>
          </div>

          { !isWebView &&
            <FooterLite editionUserGeo={edition.userGeo} />
          }
        </div>
      )
    }

    if(isWebView) {
      return (
        <div>
          <div id="custom-nav">
            <div id="gamepackage-header-wrap" className={detailsHeaderClass} data-league-uid={leagueUid}>
              <div id="gamepackage-matchup-wrap">
                { !showGameHeader &&
                  <GameStrip {...gameStrip} sport={sport} className={gameStateClass}  />
                }
                {
                  !showGameHeader && showGameDetailFooter &&
                  <GameDetailsFooter className={gameStateClass} sport={sport} summaryText={summary} summaryData={matchSummary} gameState={gameState} />
                }
              </div>
              { !showGameHeader &&
                <GlobalNavTertiary links={links} activeKey={pageType} />
              }
            </div>
          </div>
          {
            !isMobile &&
            <Ad id="banner" className="react-ad ad-slot-banner ad-wrapper" slotType="banner" kvpos="top" />
          }
          <section id="main-container" className={mainContainerClass}>
            <div className="main-content">
              {appView}
            </div>
          </section>
        </div>
      )
    }

    return (
      <section id="gamepackage-wrapper">
        {
          isDataLite && trackingImg &&
            <div style={{ maxHeight:'1px', position: 'absolute' }}><img id="omniture" src={trackingImg} alt="" width="1" height="1" /></div>
        }
        <div id="custom-nav">
          {/* showGameHeader is true only for cricket since GameHeader component is used instead of GameStrip, GameDetailsFooter & GlobalNavTertiary */}
          { !showGameHeader &&
            <GameStrip {...gameStrip} sport={sport} className={gameStateClass}  />
          }
          {
            !showGameHeader && showGameDetailFooter &&
            <GameDetailsFooter className={gameStateClass} sport={sport} summaryText={summary} summaryData={matchSummary} gameState={gameState} />
          }
          { !showGameHeader &&
            <GlobalNavTertiary links={links} activeKey={pageType} />
          }
        </div>
        {
          !isMobile &&
          <Ad id="banner" className="react-ad ad-slot-banner ad-wrapper" slotType="banner" kvpos="top" />
        }
        <section id="main-container" className={mainContainerClass}>
          <div className="main-content">
            {!isMobile &&
              <LongStripAd edition={edition}/>
            }
            {appView}
            { showBtmAdModule && edition.isAsiaRegion &&
                <Ad id="banner" className="react-ad ad-banner-mobile ad-wrapper" slotType="banner" include={[ 's' ]} kvpos="bottom" />
            }
            { showBtmAdModule && isMobile && 
              <Ad id="mpu" className="ad-slot-inview ad-slot-mobile-incontent ad-wrapper" kvpos="bottom" slotType="incontent" />
            }
          </div>
        </section>
      </section>
    )
  }

}



/** WEBPACK FOOTER **
 ** ../app/containers/GamePackage.jsx
 **/